export default class ResultsService {
	constructor() {
		this.auth = firebase.auth()
		this.ref = firebase.database().ref()
		this.resultsRef = this.ref.child('results')
	}

	get(pollId) {
		return this.resultsRef.child(pollId).once('value')
			.then((snap) => snap.value())
	}

	listen(pollId, callback) {
		const ref = this.resultsRef.child(pollId)

		ref.off()
		ref.on('value', (snap) => callback(snap.val()))

		return () => ref.off()
	}

	update(pollId, add, subtract) {
		return this.resultsRef.child(pollId).transaction((current) => {
			if (current === null) {
				return { [add]: 1 }
			}

			const result = Object.assign({}, current)

			if (Number.isInteger(add) && add >= 0) {
				result[add] = (result[add] || 0) + 1
			}
			if (Number.isInteger(subtract) && subtract >= 0) {
				result[subtract] = result[subtract] >= 0 ? result[subtract] - 1 : 0
			}

			return result
		})
	}
}



// WEBPACK FOOTER //
// ./src/services/ResultsService.js